class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user === null || user === undefined ? undefined : user.RefreshToken;
  }

  getLocalTokenExpires() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user === null || user === undefined ? undefined : user.TokenExpires;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user === null || user === undefined ? undefined : user.Token;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.Token = token;
    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  setUser(user) {
    //console.log(JSON.stringify(user))
    localStorage.setItem("user", JSON.stringify(user));
  }

  setLogin(login, password, lembrarMe) {
    if (lembrarMe === true) {
      var form = {
        login: login,
        password: password,
        lembrarMe: lembrarMe,
      };
      localStorage.setItem("loginApp", JSON.stringify(form));
    } else {
      this.removeLogin();
    }
  }

  removeLogin() {
    localStorage.removeItem("loginApp");
  }

  removeUser() {
    localStorage.removeItem("user");
  }
}

export default new TokenService();
